import React from 'react';
import ErrorMessage from '../ErrorMessage';

export function CheckBox(props: any) {
  const {
    field,
    form: { touched, errors, setFieldValue },
    customFeedbackLabel,
    type = 'checkbox',
    placeholder,
    label,
    labelClass,
    isinnerhtml='false'
  } = props;

  const onChangeText = (e: any) => {
    setFieldValue(field.name, e.target.checked);
    if (props.onChange) props.onChange(e.target.checked);
  };
  
  return (
    <div>
      <input
        type={type}
        placeholder={placeholder}
        {...field}
        {...props}
        checked={field.value}
        onChange={(e) => onChangeText(e)}
      />
      {label && isinnerhtml!=='false'?
      (<label dangerouslySetInnerHTML={{__html:label}}/>):
      (<label className={labelClass}>{label}</label>)}

      {errors[field.name] && touched[field.name] &&(
          <ErrorMessage text={errors[field.name]}/>
      )}
    </div>
  );
}